import { Component, Input, OnInit } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { CuestionarioService } from '../../../_services/cuestionario.service';
import { Cuestionario } from '../../../_models/cuestionario';
import { ProductoCuestionarioVoluntadPagoService } from '../../../_services/producto-cuestionario-voluntad-pago.service';
import { ProductoCuestionarioVoluntadPago } from '../../../_models/producto-cuestionario-voluntad-pago';

@Component( {
  selector: 'app-producto-voluntad-pago',
  templateUrl: 'producto-voluntad-pago.component.html'
} )

export class ProductoVoluntadPagoComponent implements OnInit {
  @Input() producto: Producto;
  lisCuestionarios: SelectItem[] = [];
  lisCuestionariosTodos: Cuestionario[] = [];
  carInformacionInicial = true;
  lisProductosCuestionarios: ProductoCuestionarioVoluntadPago[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  proCuestionarioSeleccionado: ProductoCuestionarioVoluntadPago;

  constructor( private proCuestionarioVoluntadPagoServicio: ProductoCuestionarioVoluntadPagoService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private nav: NavService,
               private cueServicio: CuestionarioService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreCuestionario', header: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.LBL_CUESTIONARIO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false }
    ];

    forkJoin( this.proCuestionarioVoluntadPagoServicio.listadoPorProducto( this.producto.idProducto ), this.cueServicio.listadoConRespuesta() ).subscribe( ( [ lisProductosCuestionarios, lisCuestionarios ] ) => {
      this.lisProductosCuestionarios = lisProductosCuestionarios;
      this.lisCuestionariosTodos = lisCuestionarios;
      this.cargarCuestionarios();
      this.cargarFormulario();
      this.carInformacionInicial = false;
    } );
  }

  cargarCuestionarios() {
    this.lisCuestionarios = [];
    this.lisCuestionariosTodos.map( ( s: Cuestionario ) => {
      if ( s.indicadorHabilitado && !this.lisProductosCuestionarios.find( x => x.idCuestionario === s.idCuestionario ) ) {
        this.lisCuestionarios.push( { label: s.nombre, value: s.idCuestionario } );
      }
    } );
  }


  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProductoCuestionarioVoluntadPago: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.idProductoCuestionarioVoluntadPago : null ],
      idProducto: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.idProducto : this.producto.idProducto, [ Validators.required ] ],
      idCuestionario: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.idCuestionario : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.indicadorHabilitado : true ],
      auditoriaUsuario: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.auditoriaUsuario : null ],
      auditoriaFecha: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.auditoriaFecha : null ],
      nombreCuestionario: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.nombreCuestionario : null ]
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  guardar( proCuestionario: ProductoCuestionarioVoluntadPago, habilitado?: ProductoCuestionarioVoluntadPago ) {
    const regCrear = [];
    regCrear.push( proCuestionario );
    if ( habilitado ) {
      regCrear.push( habilitado );
    }

    const tipo = (proCuestionario.idProductoCuestionarioVoluntadPago !== '' && proCuestionario.idProductoCuestionarioVoluntadPago !== null && proCuestionario.idProductoCuestionarioVoluntadPago !== undefined) ? 2 : 1;


    this.proCuestionarioVoluntadPagoServicio.bulk( regCrear ).subscribe( cuestionarios => {
      if ( tipo === 1 ) {
        const a = cuestionarios.find( x => !habilitado || x.idProductoCuestionarioVoluntadPago != habilitado.idProductoCuestionarioVoluntadPago );
        if ( a ) {
          proCuestionario.idProductoCuestionarioVoluntadPago = a.idProductoCuestionarioVoluntadPago;
        }

        const c = this.lisCuestionarios.find( x => x.value === proCuestionario.idCuestionario );
        if ( c ) {
          proCuestionario.nombreCuestionario = c.label;
        }


        this.lisProductosCuestionarios = [ ...this.lisProductosCuestionarios, proCuestionario ];

      } else {

        const a = this.lisProductosCuestionarios.findIndex( x => x.idProductoCuestionarioVoluntadPago === proCuestionario.idProductoCuestionarioVoluntadPago );
        if ( a >= 0 ) {
          this.lisProductosCuestionarios[ a ] = proCuestionario;
        }
      }

      if ( habilitado ) {
        const i = this.lisProductosCuestionarios.findIndex( x => x.idProductoCuestionarioVoluntadPago === habilitado.idProductoCuestionarioVoluntadPago );
        if ( i >= 0 ) {
          this.lisProductosCuestionarios[ i ] = habilitado;
        }
      }

      this.proCuestionarioSeleccionado = null;
      this.formulario.reset();
      this.f.idProducto.setValue( this.producto.idProducto );
      this.f.indicadorHabilitado.setValue( true );
      this.cargarCuestionarios();
      this.submitted = false;
      this.guardando = false;
      this.navServicio.setMesage( tipo );
    }, error => {
      this.guardando = false;
      this.navServicio.setMesage( 3 );
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const proCuestionario = this.formulario.value;
      const habilitado = this.lisProductosCuestionarios.find( x => x.indicadorHabilitado && proCuestionario.idProductoCuestionarioVoluntadPago !== x.idProductoCuestionarioVoluntadPago );
      if ( proCuestionario.indicadorHabilitado && habilitado ) {
        this.conServicio.confirm( {
          message: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.MSG_GUARDARHABILITADO' ),
          header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
          icon: 'fa fa-question-circle',
          key: 'cuestionarios',
          accept: () => {
            habilitado.indicadorHabilitado = false;
            this.guardar( proCuestionario, habilitado );
          },
          reject: () => {
            this.guardando = false;
          }
        } );
      } else {
        this.guardar( proCuestionario );
      }
    }
  }

  editar( proCuestionario: ProductoCuestionarioVoluntadPago ) {
    this.proCuestionarioSeleccionado = proCuestionario;
    this.submitted = false;
    this.cargarFormulario();
  }

  inhabilitar( item: ProductoCuestionarioVoluntadPago ) {
    if ( !item.indicadorHabilitado ) {
      this.guardando = true;
      this.proCuestionarioVoluntadPagoServicio.actualizar( item ).subscribe( producto => {
        this.actualizarLista();
      } );
    } else {
      this.guardando = true;
      if ( this.lisProductosCuestionarios.find( x => x.indicadorHabilitado && x.idProductoCuestionarioVoluntadPago !== item.idProductoCuestionarioVoluntadPago ) ) {
        this.lisProductosCuestionarios.map( ( s: ProductoCuestionarioVoluntadPago ) => {
          if ( s.indicadorHabilitado && s.idProductoCuestionarioVoluntadPago !== item.idProductoCuestionarioVoluntadPago) {
            s.indicadorHabilitado = false;
            forkJoin( this.proCuestionarioVoluntadPagoServicio.actualizar( s ),
              this.proCuestionarioVoluntadPagoServicio.actualizar( item ) ).subscribe( ( [ antiguoHabilitado, nuevoHabilitado ] ) => {
              this.actualizarLista();
            } );
          }
        } );
      } else {
        this.proCuestionarioVoluntadPagoServicio.actualizar( item ).subscribe( producto => {
          this.actualizarLista();
        } );
      }

    }

  }

  actualizarLista() {
    this.lisProductosCuestionarios = null;
    this.proCuestionarioVoluntadPagoServicio.listadoPorProducto( this.producto.idProducto ).subscribe( lista => {
      this.lisProductosCuestionarios = lista;
      this.guardando = false;
    } )
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'cuestionarios',
        accept: () => {
          this.formulario.reset();
          this.f.idProducto.setValue( this.producto.idProducto );
          this.f.indicadorHabilitado.setValue( true );
          this.submitted = false;
          this.proCuestionarioSeleccionado = null;
        },
        reject: () => {
        }
      } );
    } else {
      this.formulario.reset();
      this.f.idProducto.setValue( this.producto.idProducto );
      this.f.indicadorHabilitado.setValue( true );
      this.submitted = false;
      this.proCuestionarioSeleccionado = null;
    }
  }


}
